<template>
  <div>
    <div class="text-center">
      <div class="mb-10 mt-5 text-center">
        <div ref="numCount" class="d-inline-block">
          <v-icon class="mx-2" v-for="(x, i) in countTyped" :key="'countTyped' + i"
            >mdi-circle</v-icon
          >
          <v-icon class="mx-2" v-for="(x, i) in countUntyped" :key="'countUntyped' + i"
            >mdi-circle-outline</v-icon
          >
        </div>
      </div>
      <div class="my-5">
        <div>
          <v-btn
            fab
            outlined
            x-large
            class="text-h4 ma-2 number"
            @click="clickNumber('1')"
            v-shortkey="[1]"
            @shortkey="keyboard('1')"
          >
            <v-icon size="50">mdi-numeric-1</v-icon>
          </v-btn>
          <v-btn
            fab
            outlined
            x-large
            class="text-h4 ma-2 number"
            @click="clickNumber('2')"
            v-shortkey="[2]"
            @shortkey="keyboard('2')"
          >
            <v-icon size="50">mdi-numeric-2</v-icon>
          </v-btn>
          <v-btn
            fab
            outlined
            x-large
            class="text-h4 ma-2 number"
            @click="clickNumber('3')"
            v-shortkey="[3]"
            @shortkey="keyboard('3')"
          >
            <v-icon size="50">mdi-numeric-3</v-icon>
          </v-btn>
        </div>
        <div>
          <v-btn
            fab
            outlined
            x-large
            class="text-h4 ma-2 number"
            @click="clickNumber('4')"
            v-shortkey="[4]"
            @shortkey="keyboard('4')"
          >
            <v-icon size="50">mdi-numeric-4</v-icon>
          </v-btn>
          <v-btn
            fab
            outlined
            x-large
            class="text-h4 ma-2 number"
            @click="clickNumber('5')"
            v-shortkey="[5]"
            @shortkey="keyboard('5')"
          >
            <v-icon size="50">mdi-numeric-5</v-icon>
          </v-btn>
          <v-btn
            fab
            outlined
            x-large
            class="text-h4 ma-2 number"
            @click="clickNumber('6')"
            v-shortkey="[6]"
            @shortkey="keyboard('6')"
          >
            <v-icon size="50">mdi-numeric-6</v-icon>
          </v-btn>
        </div>
        <div>
          <v-btn
            fab
            outlined
            x-large
            class="text-h4 ma-2 number"
            @click="clickNumber('7')"
            v-shortkey="[7]"
            @shortkey="keyboard('7')"
          >
            <v-icon size="50">mdi-numeric-7</v-icon>
          </v-btn>
          <v-btn
            fab
            outlined
            x-large
            class="text-h4 ma-2 number"
            @click="clickNumber('8')"
            v-shortkey="[8]"
            @shortkey="keyboard('8')"
          >
            <v-icon size="50">mdi-numeric-8</v-icon>
          </v-btn>
          <v-btn
            fab
            outlined
            x-large
            class="text-h4 ma-2 number"
            @click="clickNumber('9')"
            v-shortkey="[9]"
            @shortkey="keyboard('9')"
          >
            <v-icon size="50">mdi-numeric-9</v-icon>
          </v-btn>
        </div>
        <div>
          <v-btn
            fab
            outlined
            x-large
            class="text-h4 ma-2 number"
            @click="clickNumber('0')"
            v-shortkey="[0]"
            @shortkey="keyboard('0')"
          >
            <v-icon size="50">mdi-numeric-0</v-icon>
          </v-btn>
        </div>
      </div>
    </div>

    <div class="d-flex justify-space-between">
      <v-btn large text color="primary" @click="$emit('clickBack')">
        BACK
      </v-btn>
      <v-btn
        large
        text
        color="grey"
        @click="clickDelete"
        v-shortkey="['backspace']"
        @shortkey="clickDelete"
      >
        DELETE
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "LockNumpad",
  props: {
    expected: {
      default: null,
      type: String,
    },
    listen_keyboard: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      value: "",
    };
  },
  methods: {
    clickNumber(num) {
      if (this.countTyped > 3) return;
      this.value += num;
      this.$refs.numCount.classList.remove("animate__animated", "animate__shakeX", "animate__fast");
    },
    clickDelete() {
      this.value = this.value.slice(0, -1);
    },
    reset() {
      this.value = "";
      this.$refs.numCount.classList.remove("animate__animated", "animate__shakeX", "animate__fast");
    },
    keyboard(num) {
      console.log(num, "numpad keyboard shortcut");
      if (this.listen_keyboard) {
        this.clickNumber(num);
      }
    },
  },
  watch: {
    value(val) {
      // console.log(val, "watcher");
      if (val.length == 4) {
        if (!this.expected) {
          this.$emit("newLockCode", this.value);
        } else if (val == this.expected) {
          this.$emit("unlockSuccess");
        } else {
          this.value = "";
          this.$refs.numCount.classList.add(
            "animate__animated",
            "animate__shakeX",
            "animate__fast"
          );
          this.$emit("lockFailure");
        }
      }
    },
  },
  computed: {
    countTyped() {
      return this.value.length;
    },
    countUntyped() {
      return 4 - this.value.length;
    },
  },
};
</script>

<style scoped>
.number:before {
  background-color: transparent !important;
}
</style>
